import fetchWithDefaults from '../../CommonUtils/fetchWithDefaults';
import { MESSAGES } from '../../CommonConstants';
import { queryConsumerNetWorthWidget } from './api/queryConsumerNetWorthWidget';
import { UPDATE_APEX_ACCOUNT_STATUS } from '../../Apex/StatusViews/StatusViews.meta';

export const NETWORTH_DATA_SET = 'NETWORTH_WIDGET.NETWORTH_DATA_SET';
export const IS_FETCHING_NETWORTH_DATA_SET = 'NETWORTH_WIDGET.IS_FETCHING_NETWORTH_DATA_SET';
export const ERRORS_SET = 'NETWORTH_WIDGET.ERRORS_SET';
export const ORION_ACCOUNTS_ENRICH = 'NETWORTH_WIDGET.ORION_ACCOUNTS_ENRICH';

export const setErrors = payload => ({
  type: ERRORS_SET,
  payload,
});

export const setNetWorthData = payload => ({
  type: NETWORTH_DATA_SET,
  payload,
});

const enrichOrionAccounts = payload => ({
  type: ORION_ACCOUNTS_ENRICH,
  payload,
});

export const setIsFetchingNetWorthData = (isFetching, isInitialFetch = false) => ({
  type: IS_FETCHING_NETWORTH_DATA_SET,
  payload: { isFetching, isInitialFetch },
});

export const setAccountApexStatus = (accountId, apexStatus) => ({
  type: UPDATE_APEX_ACCOUNT_STATUS,
  payload: { accountId, ApexStatus: apexStatus },
});

export const fetchNetWorthData = (clientId, isInitialFetch) => async dispatch => {
  dispatch(setIsFetchingNetWorthData(true, isInitialFetch));

  try {
    const response = await queryConsumerNetWorthWidget(clientId);

    dispatch(setNetWorthData(response));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    dispatch(setErrors(err.message));
  } finally {
    dispatch(setIsFetchingNetWorthData(false));
  }
};

export const fetchOrionAccountsData = clientId => async dispatch => {
  try {
    const response = await fetchWithDefaults(
      `/Consumer/OrionAccountsWidgets/AccountsInformation?clientId=${clientId}`,
    );

    if (response.ok) {
      const { success, payload } = await response.json();

      if (success) {
        const { viewData } = payload;

        dispatch(
          enrichOrionAccounts(
            viewData.reduce((acc, account) => ({ ...acc, [account.accountId]: account }), []),
          ),
        );
      }
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    dispatch(setErrors([MESSAGES.GENERIC_ERROR]));
  }
};
